import React from 'react'
import { Avatar, Box, Grid, Typography } from '@mui/material'
import styles from './index.module.css'
import { normalizeAvatarUrl } from '../../../utils/avatar'

const TEXT_GREY = '#55656d'

const formatAddressLines = (address) => {
  if (!address) return [];
  const line1 = address.addressLine1 || '';
  const line2 = address.addressLine2 || '';
  const city = address.city || '';
  const state = address.stateProvince || '';
  const postal = address.postalCode || '';
  const country = address.country || '';
  const cityLine = [city, state].filter(Boolean).join(', ');
  const postalLine = [postal, country].filter(Boolean).join(' ');
  return [line1, line2, cityLine, postalLine].filter(Boolean);
};

const Footer = ({ rep, footerAddress }) => {
  const [avatarVisible, setAvatarVisible] = React.useState(true)

  React.useEffect(() => {
    setAvatarVisible(true)
  }, [rep?.avatarUrl, rep?.profilePicture, rep?.profile_picture, rep?.avatar, rep?.photoUrl])

  // Normalize name/email/phone regardless of backend shape
  const first = rep?.first_name?.trim?.() || ''
  const last  = rep?.last_name?.trim?.() || ''
  const name  = (rep?.name?.trim?.() || `${first} ${last}`.trim()) || '—'
  const email = rep?.email || '—'
  const phone = rep?.phone || rep?.phone_number || '—'
  const title = rep?.title || ''
  const avatarUrl = normalizeAvatarUrl(
    rep?.avatarUrl ||
    rep?.profilePicture ||
    rep?.profile_picture ||
    rep?.avatar ||
    rep?.photoUrl ||
    null
  )

  const companyName =
    footerAddress?.companyName || 'Elite Promotional Marketing (Elite Sportswear & Awards Ltd)';
  const addressLines = formatAddressLines(footerAddress);

  return (
    <>
      <Grid container className={styles.footerContainer} alignItems="center" spacing={2}>
        {/* Rep block (dynamic) */}
        <Grid item md={4} xs={12}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {avatarUrl && avatarVisible ? (
              <Avatar
                src={avatarUrl}
                alt={name}
                imgProps={{ onError: () => setAvatarVisible(false) }}
                sx={{ width: 48, height: 48 }}
              />
            ) : null}
            <Box>
              <Typography color={TEXT_GREY} variant="body2">{name}</Typography>
              {title && <Typography color={TEXT_GREY} variant="body2">{title}</Typography>}
              <Typography color={TEXT_GREY} variant="body2">{email}</Typography>
              <Typography color={TEXT_GREY} variant="body2">{phone}</Typography>
            </Box>
          </Box>
        </Grid>

        {/* Company block */}
        <Grid item md={4} xs={12}>
          <Box>
            <Typography color={TEXT_GREY} variant='body2'>
              {companyName}
            </Typography>
            {addressLines.length ? (
              addressLines.map((line) => (
                <Typography key={line} color={TEXT_GREY} variant='body2'>
                  {line}
                </Typography>
              ))
            ) : (
              <>
                <Typography color={TEXT_GREY} variant='body2'>14703-118 Ave NW</Typography>
                <Typography color={TEXT_GREY} variant='body2'>Edmonton, Alberta T5L 2M7</Typography>
                <Typography color={TEXT_GREY} variant='body2'>Canada</Typography>
              </>
            )}
          </Box>
        </Grid>
      </Grid>

      {/* Full-width bottom image row */}
      <Grid item xs={12}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mt: '55px',
            mb: '35px',
          }}
        >
          <img
            src="https://elitepromomarketing.com/wp-content/uploads/2025/08/CLIENT-FACING-ELITE-CORE-EMAIL-SIGNATURE-01.png"
            alt="Elite Core Footer"
            style={{ maxWidth: '400px', height: 'auto' }}
          />
        </Box>
      </Grid>
    </>
  )
}

export default Footer
